import { useState } from 'react';
import { Box, SxProps, type Theme } from '@mui/material';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_jobSearchResults_seoSegmentationJob as SEOJob } from '@/__generated__/seoSegmentationListingPage';
import { ReadMore } from '@/components/common/ReadMore';
import { useResponsive } from '@/components/hooks/useResponsive';

interface JobDescriptionProps {
  jobDescription: SEOJob['description'];
  sx?: SxProps<Theme>;
}

export const JobDescription = ({ sx, jobDescription }: JobDescriptionProps) => {
  const { isSmallViewport, isMediumViewport } = useResponsive();
  const [isExpanded, setIsExpanded] = useState(false);

  const getCharLimit = () => {
    if (isSmallViewport) {
      return 200;
    }
    if (isMediumViewport) {
      return 120;
    }
    return 140;
  };

  return (
    <Box sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      <ReadMore
        color="textPrimary"
        component="div"
        variant="body2"
        charLimit={getCharLimit()}
        value={jobDescription}
        showMoreLabel={isExpanded ? 'less' : 'read more'}
        onClick={() => setIsExpanded(!isExpanded)}
      />
    </Box>
  );
};
